/**
 * GP-1379 — shared deep-link pieces for the Delivery Status queue.
 *
 * Extracted here (batch-5 review) because TWO independent copies of the
 * stage→queue routing existed: OrdersTable's "Click to go to queue" (fixed by
 * GP-1379) and orderQueueColumns' Status/Stage chip (used by All Orders, which
 * still sent an out-for-delivery pickup order to the Delivery tab that
 * structurally cannot contain it). A neutral module both can import — they
 * cannot import each other, OrdersTable already depends on orderQueueColumns.
 */

/** The Delivery Status queue route — the only one with pickup/delivery sub-tabs. */
export const DELIVERY_STATUS_ROUTE = '/order-fulfillment/delivery-status';

/**
 * Which Delivery Status sub-tab a queue deep-link should open on.
 *
 * The queue's Delivery and Pickup tabs partition on the order's fulfilment
 * method — the Delivery tab asks the API for `deliveryMethod = 'delivery'`, so a
 * pickup order can never appear on it. Landing an out-for-delivery PICKUP order
 * on the default tab is what made ORD-20260626-121521-408 look like it had
 * vanished from fulfilment entirely.
 *
 * Returns `null` when the order's method is unknown: the queue then keeps its
 * own default rather than being sent to a tab we guessed at.
 */
export const deliveryStatusTabFor = (order: any): 'pickup' | 'delivery' | null => {
  const method = String(order?.deliveryMethod ?? order?.orderType ?? '').toLowerCase();
  if (method === 'pickup') return 'pickup';
  if (method === 'delivery') return 'delivery';
  return null;
};
